// @flow

import clsx from 'clsx';
import { LoaderCircle } from 'lucide-react';

import { Base, Fqdn, Placeholder } from '@gandi/ui';

import styles from './ProvidedPlaceholderRow.scss';

type Props = {
  tagName?: 'li',
  fqdn: string,
};

export function ProvidedPlaceholderRow({
  fqdn,
  tagName,
}: Props): React.MixedElement {
  return (
    <Base tagName={tagName} className={styles.root}>
      <Base flex flexJustifyBetween>
        <div className={styles.container}>
          <span className={clsx(styles.loaderCircle, styles.animation)}>
            <LoaderCircle />
          </span>

          <Fqdn maxLength={42}>{fqdn}</Fqdn>
        </div>
      </Base>
      <div className={styles.placeholder}>
        <Placeholder chars={10} />
      </div>
    </Base>
  );
}
